import { BarcodeScannerProvider } from './../../../providers/barcode-scanner-provider';
import { SayimGirisiPage } from './../sayim-girisi/sayim-girisi';
import { Ortak } from './../../../providers/ortak';
import { StokeklePage } from './../stokekle/stokekle';
import { Component } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { BllOrtak } from '../../../providers/bll/bll-ortak';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { ActionSheetController } from 'ionic-angular'

@Component({
  selector: 'page-stoklar',
  templateUrl: 'stoklar.html',
})
export class StoklarPage {
  aranan = "";
  skip: number = 0;
  take: number = 50;
  UrunListesi = [];
  KategoriListesi = [];
  secilenkategoriID = "";
  aranankategori = "";
  etiketid: any = { Id: -1, StokKartiID: "", StokAdi: "" };
  constructor(private barcodeScanner: BarcodeScannerProvider, public navCtrl: NavController, public actionSheetCtrl: ActionSheetController, public ortak: Ortak, public modalCtrl: ModalController, public bllOrtak: BllOrtak, public navParams: NavParams) {
  }
  ionViewDidLoad() {
    this.UrunAra();
    this.KategoriGetir();
  }
  KategoriGetir() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "KategoriListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.KategoriListesi = sonuc.SonucObject;
    })
  }

  UrunAra() {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    formData.append("aranankategori", this.secilenkategoriID)
    console.log("Servis URL:", this.ortak.ServisUrl);
    this.bllOrtak.islem(formData, "Stoklar", "", false).then(a => {
      var sonuc = <any>a;
      this.UrunListesi = sonuc.SonucObject;
    }).catch(x => {
      console.log(x);
    })
  }
  urunler(e) {

    if (e.keyCode == 13) {
      this.UrunAra();
    }
  }
  barkodOkut() {
    this.barcodeScanner.barkodOku().then(a => {
      var sonuc = <any>a;
      this.aranan = sonuc.text;
      this.UrunAra();
    })
  }
  yeni() {
    let modal = this.modalCtrl.create(StokeklePage, "", { cssClass: "genisekran" });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
  }
  StokSil(urun) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      formData.append("LogicalRef", urun.ID);
      this.bllOrtak.islem(formData, "StokSil", "", true).then(a => {
      }).catch(x => {
        this.ortak.showErrorAlert();
      })
      this.UrunAra();
    })
  }
  StokGuncelle(Stok) {
    let modal = this.modalCtrl.create(StokeklePage, { vwUrun: Stok }, { cssClass: "genisekran" });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
  }
  SayimGirisi(Stok) {
    let modal = this.modalCtrl.create(SayimGirisiPage, { vwUrun: Stok });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
  }
  barkodara() {
    this.barcodeScanner.barkodOku().then(barcodeData => {
      console.log('Barcode data', barcodeData);
    }).catch(err => {
      console.log('Error', err);
    });
  }
  Islemler(Stok) {
    const actionSheet = this.actionSheetCtrl.create({
      title: 'Stok  İşlemleri',
      buttons: [
        {
          text: 'Etiket Bas',
          handler: () => {
            this.etiketgonder(Stok);
          }
        },
        {
          text: 'Sayım Girişi',
          handler: () => {
            this.SayimGirisi(Stok);
          }
        }, {
          text: 'Düzenle',
          handler: () => {
            this.StokGuncelle(Stok);
          }
        }, {
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }
  etiketgonder(Stok) {
    this.etiketid.StokKartiID = Stok.ID;
    this.etiketid.StokAdi = Stok.StokAdi;
    this.ortak.showConfirmAlert("Uyarı", "Etiket Basıma Gönderilecek. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      formData.append("Etiket_json", JSON.stringify(this.etiketid));
      this.bllOrtak.islem(formData, "EtiketGonder", "", true).then(a => {
        var sonuc = <any>a;
        if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
        if (sonuc.Sonuc == 98) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
      }).catch(x => {
        this.ortak.showErrorAlert();
      })
    })
  }
  kalemListesiClick(item) {
    this.UrunListesi = item;
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/StokIslemleri/stoklar/stoklar.ts